/** ----------------------------------------
    Imports
 ---------------------------------------- */

import { NotificationService } from '@store/service/NotificationService';

/** ----------------------------------------
    Actions
---------------------------------------- */

const actions = {

    /** ----------------------------------------
        Update
    ---------------------------------------- */

    async fetchAll({ commit }: any) {
        const notificationService = new NotificationService(this);
        return notificationService.getAll().then(response => {
            if (response instanceof Error)
                return response;

            commit('setNotifications', response);
        });
    },

    /** ----------------------------------------
        Read
    ---------------------------------------- */

    async setRead({ commit }: any, payload: any) {
        const notificationService = new NotificationService(this);
        return notificationService.putRead(payload).then(response => {
            if (response instanceof Error)
                return response;

            if (payload === null) {
                commit('setAllRead');
            } else {
                commit('setRead', payload);
            }
        });
    },
};

/** ----------------------------------------
    Export Actions
---------------------------------------- */

export default actions;